import { render, staticRenderFns } from "./news-mask.vue?vue&type=template&id=8800255c&scoped=true&"
import script from "./news-mask.vue?vue&type=script&lang=js&"
export * from "./news-mask.vue?vue&type=script&lang=js&"
import style0 from "./news-mask.vue?vue&type=style&index=0&id=8800255c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8800255c",
  null
  
)

export default component.exports